









import { Component, Vue } from 'vue-property-decorator'
import Overlay from '@/views/Overlay.vue'

@Component({
  components: {
    Overlay,
  },
  computed: {
    routerTransition() {
      return this.$store.state.loading ? 'router-fade' : 'router-fade'
    },
    routerTransitionDuration() {
      return this.$store.state.loading ? 0 : 1000
    },
  },
  mounted() {
    this.$store.commit('_SCRIPTS_SET_GAPI', (this as any).$gapi)
  },
})
export default class App extends Vue {}
